import { render, staticRenderFns } from "./avatar-menu.vue?vue&type=template&id=b576e97c&scoped=true"
import script from "./avatar-menu.vue?vue&type=script&lang=js"
export * from "./avatar-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b576e97c",
  null
  
)

export default component.exports